import {reqContactList} from '@/api';

const state = {
  contactList: [],
  firstContact: {},
}
const mutations = {
  GET_CONTACT_LIST(state, results) {
    state.contactList = results.results;
    if (results.results) {
      state.firstContact = results.results[0];
    }
  }
}
const actions = {
  // 获取联系方式列表
  async getContactList({commit}) {
    let results = await reqContactList();
    // console.log(results)
    if (results.status === 200) {
      commit("GET_CONTACT_LIST", results)
    } else {
      return Promise.reject(new Error('联系方式请求失败！'));
    }
  },
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}